import _ from "lodash";

export const constants = {
  // BASE_URL: "http://ec2-34-210-211-227.us-west-2.compute.amazonaws.com:7771"
  // BASE_URL: ''
  BASE_URL: "",
  // BASE_URL: 'http://localhost:7111'
};

export const DATE_FORMAT = "MM/DD/YYYY";

export const pageTitleMapper = {
  //Home
  "/home": {
    module: "",
    pageTitle: "Home",
  },

  "/home/userReview": {
    module: "",
    pageTitle: "Home > Application User Access Review",
  },
  "/home/BusinessInfoConfig": {
    module: "",
    pageTitle: "Home > Business Info",
  },
  "home/Devices": {
    module: "",
    pageTitle: "Home > Devices",
  },
  "home/Cloud Accounts": {
    module: "",
    pageTitle: "Home > Cloud Accounts",
  },
  "home/Identities(Users) ": {
    module: "",
    pageTitle: "Home > Identities(Users) ",
  },
  //Observability //title changed from Observability to DevOps Insights
  "/observability/flowMetrics": {
    module: "DevOps Insights > ",
    pageTitle: "Flow Metrics",
  },
  "/observability/doraMetrics": {
    module: "DevOps Insights > ",
    pageTitle: "Dora Metrics",
  },
  "/observability/peopleMetrics": {
    module: "DevOps Insights > ",
    pageTitle: "People Metrics",
  },
  "/observability/productivityMetrics": {
    module: "DevOps Insights > ",
    pageTitle: "Productivity Metrics",
  },
  "/observability/opsMetrics/incidentManagement": {
    module: "DevOps Insights > ",
    pageTitle: "Ops Metrics: Incident Management",
  },
  "/observability/opsMetrics/changeManagement": {
    module: "DevOps Insights > ",
    pageTitle: "Ops Metrics: Change Management",
  },
  "/observability/SBOM": {
    module: "DevOps Insights > ",
    pageTitle: "SBOM",
  },
  //GNC
  "/gnc/CloudCostInsights": {
    module: "Governance & Compliance > ",
    pageTitle: "Cloud Cost Insights",
  },

  // "/gnc/compliance": {
  //   module: "Governance & Compliance - ",
  //   pageTitle: "Jenkins",
  // },
  // "/gnc/bitbucketTrend": {
  //   module: "Governance & Compliance - ",
  //   pageTitle: "Bitbucket",
  // },
  "/gnc/licenseManagement": {
    module: "Governance & Compliance > ",
    pageTitle: "License Management",
  },
  "/gnc/PII": {
    module: "Governance & Compliance > ",
    pageTitle: "PII Data",
  },
  // "/gnc/AdminActivity": {
  //   module: "Governance & Compliance > ",
  //   pageTitle: "Admin Activity",
  // },
  "/RiskAssessment/RiskAssessment": {
    module: "Governance & Compliance >",
    pageTitle: "Risk Assessment",
  },
  "RiskAssessment/AddRiskAssessment": {
    module: "Risk Assessment > ",
    pageTitle: "Create Risk Assessment",
  },
  "/RiskAssessment/RiskAssessment/Topics": {
    module: "Risk Assessment - ",
    pageTitle: "Topic Name",
  },
  "/RiskAssessment/TopicNameAssessment": {
    module: "Risk Assessment - ",
    pageTitle: "Topic Name",
  },
  "/RiskAssessment/RiskAssessment/Topics/SubTopics": {
    module: "Risk Assessment - ",
    pageTitle: "Sub Topic Name",
  },
  "/RiskAssessment/RiskAssessment/Topics/SubTopics/Clause/Questions": {
    module: "Risk Assessment - ",
    pageTitle: "Questions",
  },
  "/RiskAssessment/RiskAssessment/Topics/SubTopics/Clause/Questions/Assessment":
  {
    module: "Risk Assessment - ",
    pageTitle: "Assessment",
  },
  // Summary
  "/gnc/Compliance": {
    module: "Governance & Compliance > ",
    pageTitle: "Summary",
  },
  //Vulnerabilities
  "/gnc/Vulnerability": {
    module: "Governance & Compliance > ",
    pageTitle: "Vulnerability Management",
  },
  "/gnc/CISBenchmarkCompliance": {
    module: "Governance & Compliance > ",
    pageTitle: "CIS Benchmark Compliance",
  },
  "/gnc/cisoInsights": {
    module: "Governance & Compliance > ",
    pageTitle: "CISO Insights",
  },
  //compliance

  "/gnc/regulatoryCompliance/trmgCompliance": {
    module: "Governance & Compliance > ",
    pageTitle: "TRMG Compliance",
  },
  "/gnc/regulatoryCompliance/RMitCompliance": {
    module: "Governance & Compliance > ",
    pageTitle: "RMiT Compliance",
  },
  "/gnc/regulatoryCompliance/circular09Compliance": {
    module: "Governance & Compliance > ",
    pageTitle: "Circular 09 Compliance",
  },
  "/gnc/Compliance/securityHub": {
    module: "Governance & Compliance > ",
    pageTitle: "Security Hub Findings",
  },
  "/gnc/Compliance/identityComplianceManagement": {
    module: "Governance & Compliance > ",
    pageTitle: "Identity Compliance Management",
  },
  "/gnc/Compliance/identityComplianceManagementNormal": {
    module: "Governance & Compliance - ",
    pageTitle: "Identity Compliance Management",
  },
  "/gnc/Compliance/identityComplianceManagementCloud": {
    module: "Governance & Compliance - ",
    pageTitle: "Identity Compliance Management",
  },

  "/gnc/PCIDSSCompliance": {
    module: "Governance & Compliance > ",
    pageTitle: "PCI-DSS Compliance",
  },
  "/gnc/CISCompliance": {
    module: "Governance & Compliance > ",
    pageTitle: "CIS Compliance",
  },
  "/gnc/Compliance/Summary": {
    module: "Governance & Compliance > ",
    pageTitle: "Summary",
  },
  "/gnc/Compliance/UserAccessManagement": {
    module: "Governance & Compliance > ",
    pageTitle: "CISO Dashboard",
  },
  // "/gnc/UserAccessReview": {
  //   module: "Governance & Compliance > ",
  //   pageTitle: "User Access Review",
  // },
  //CISO Dashboard
  "/gnc/CISOInsights": {
    module: "Governance & Compliance > ",
    pageTitle: "CISO Insights",
  },
  "/gnc/securityHubFindings": {
    module: "Governance & Compliance > ",
    pageTitle: "CISO Insights",
  },
  "/gnc/trmgCompliance": {
    module: "Governance & Compliance > ",
    pageTitle: "CISO Insights",
  },
  "/gnc/RMiTCompliance": {
    module: "Governance & Compliance > ",
    pageTitle: "CISO Insights",
  },
  "/gnc/circular09Compliance": {
    module: "Governance & Compliance > ",
    pageTitle: "CISO Insights",
  },
  "/gnc/CISBenchmarkCompliance": {
    module: "Governance & Compliance > ",
    pageTitle: "CISO Insights",
  },
  "/gnc/userAccessReview": {
    module: "Governance & Compliance > CISO Insights > ",
    pageTitle: "User Access Review",
  },

  //Configuration - CMDB paths (moved from Efficiency)
  "/configuration/cmdb/CMDBOverview": {
    module: "Configuration > CMDB > ",
    pageTitle: "CMDB Overview",
  },
  "/configuration/cmdb/projects": {
    module: "Configuration > CMDB > ",
    pageTitle: "Projects",
  },
  "/configuration/cmdb/Devices": {
    module: "Configuration > CMDB > ",
    pageTitle: "Device Configuration",
  },
  "/configuration/cmdb/UserInfoConfig": {
    module: "Configuration > CMDB > ",
    pageTitle: "Users",
  },
  "/configuration/cmdb/cloudaccounttable/cloudaccount": {
    module: "Configuration > CMDB > ",
    pageTitle: "Cloud Accounts",
  },
  "/configuration/cmdb/BusinessInfoConfig": {
    module: "Configuration > CMDB > ",
    pageTitle: "Business Info",
  },
  "/configuration/cmdb/applicationConfiguration": {
    module: "Configuration > CMDB > ",
    pageTitle: "Application Configuration",
  },
  "/configuration/auditLog": {
    module: "Configuration > ",
    pageTitle: "Audit Log",
  },
  //Configuration
  "/configuration/administration/tools": {
    module: "Configuration > administration >",
    pageTitle: "Tools",
  },
  "/configuration/administration/tools/bambooRole": {
    module: "Configuration > ",
    pageTitle: "Bamboo Roles",
  },
  "/configuration/administration/tools/bitbucketRole": {
    module: "Configuration > ",
    pageTitle: "Bitbucket Roles",
  },
  "/configuration/administration/tools/jenkinsRole": {
    module: "Configuration > ",
    pageTitle: "Jenkins Roles",
  },
  "/configuration/administration/tools/nexusRole": {
    module: "Configuration > ",
    pageTitle: "Nexus Roles",
  },
  "/configuration/administration/tools/jfrogRole": {
    module: "Configuration > ",
    pageTitle: "JFrog Roles",
  },
  "/configuration/administration/tools/jiracloudRole": {
    module: "Configuration > ",
    pageTitle: "Jira Cloud Roles",
  },
  "/configuration/administration/tools/jiraconfiguration": {
    module: "Configuration > ",
    pageTitle: "Jira Configuration",
  },
  "/configuration/administration/tools/confluencecloudRole": {
    module: "Configuration > ",
    pageTitle: "Confluence Cloud Roles",
  },
  "/configuration/administration/tools/sonarqubeRole": {
    module: "Configuration > ",
    pageTitle: "SonarQube Roles",
  },
  "/configuration/administration/tools/SeveritySLAConfigurationRole": {
    module: "Configuration > ",
    pageTitle: "Severity SLA Configuration",
  },
  "/configuration/administration/groups": {
    module: "Configuration > administration >",
    pageTitle: "Groups",
  },
  "/configuration/administration/PIIDataConfiguration": {
    module: "Configuration > administration >",
    pageTitle: "PII Data Configuration",
  },
  "/configuration/administration/IAMPolicyCategorization": {
    module: "Configuration > administration >",
    pageTitle: "IAM Policy Categorization",
  },
  "/configuration/administration/AWSStateCategorization": {
    module: "Configuration > administration >",
    pageTitle: "AWS State Categorization",
  },
  "/configuration/administration/AWSConfiguration": {
    module: "Configuration >",
    pageTitle: "AWS Configuration",
  },
  "/configuration/administration/Schedulers": {
    module: "Configuration > administration >",
    pageTitle: "Scheduler",
  },
  "/configuration/administration/CloudCost": {
    module: "Configuration > administration >",
    pageTitle: "Scheduler",
  },
  // "/configuration/settings/DataImportScheduler": {
  //   module: "Configuration > Settings >",
  //   pageTitle: "Data Import",
  // },
  "/configuration/administration/ldapConfig": {
    module: "Configuration > Administration >",
    pageTitle: "LDAP Configuration",
  },
  "/configuration/administration/smtpConfig": {
    module: "Configuration > Administration >",
    pageTitle: "SMTP Configuration",
  },
  "/configuration/administration/licenseConfig": {
    module: "Configuration > Administration >",
    pageTitle: "License Configuration",
  },
  "/configuration/administration/userManagement": {
    module: "Configuration > Administration >",
    pageTitle: "User Management",
  },
  "/configuration/administration/loggingConfig": {
    module: "Configuration > Administration >",
    pageTitle: "Logging Configuration",
  },
  "/configuration/cmdb/BusinessInfoConfig": {
    module: "Configuration > CMDB >",
    pageTitle: "Business Info",
  },
  "/configuration/cmdb/BusinessInfoConfig/roleAllocation": {
    module: "Configuration > CMDB >",
    pageTitle: "Role Allocation",
  },

  "/configuration/cmdb/UserInfoConfig": {
    module: "Configuration > CMDB >",
    pageTitle: "Users",
  },

  "/configuration/cmdb/Devices": {
    module: "Configuration > CMDB >",
    pageTitle: "Devices ",
  },
  "/configuration/cmdb/DeviceConfig/:id": {
    module: "Configuration > CMDB >",
    pageTitle: "Devices/${id}",
  },
  "/configuration/cmdb/CMDBOverview": {
    module: "Configuration >",
    pageTitle: " CMDB",
  },
  "/configuration/cmdb/cloudaccounttable/cloudaccount": {
    module: "Configuration > CMDB >",
    pageTitle: "Cloud Accounts",
  },
  "/configuration/cmdb/AssessmentQuestionnaire": {
    module: "Configuration > CMDB >",
    pageTitle: "Risk Assessment",
  },
  "/configuration/cmdb/Devices/licenseconfigpage": {
    module: "Configuration > CMDB > Devices >",
    pageTitle: "OS License Config",
  },
  "/configuration/cmdb/Devices/newprovisionpage": {
    module: "Configuration > CMDB > Devices >",
    pageTitle: "Infra Provisioning",
  },
  "/configuration/cmdb/users": {
    module: "Configuration > CMDB > ",
    pageTitle: "Users",
  },
  "/configuration/cmdb/accountids": {
    module: "Configuration > CMDB > ",
    pageTitle: "Cloud Accounts",
  },
  "/efficiency/ApplicationDeatails-APC": {
    // module: "Configuration -",
    pageTitle: "Application Deatails - APC",
  },
  "/configuration/cmdb/applicationConfiguration": {
    module: "CMDB > ",
    pageTitle: "Application Configuration",
  },
};

export const getPageTitle = (pathName, routes) => {
  console.log("path name", routes);
  _.flatMapDeep(routes);
  const pathNameString = pathName.split("/");
  console.log("string", pathNameString);
  let returnString = "";
  pathNameString.map((name, index) => {
    name = _.capitalize(decodeURIComponent(name));
    if (name) {
      index < pathNameString.length - 1
        ? (returnString += `${name} > `)
        : (returnString += name);
    }
  });
  return returnString;
};

export const pathNames = {
  DevOpsInsights: "DevOps Insights",
  cmdb: "CMDB",
  Businessinfoconfig: "Business Info Config",
  gnc: "Governance & Compliance",
  Vulnerability: "Vulnerability Management",
  compliance: "",
  Compliance: "",
  trmgCompliance: "TRMG Compliance",
  // "SBOMCompliance": "SBOM",
  circular09Compliance: "Circular 09 Compliance",
  securityHub: "Security Hub Findings",
  identityComplianceManagement: "Identity Compliance Management",
  CISBenchmarkCompliance: "CIS Benchmark Compliance",
  PII: "PII Data",
  PCIDSSCompliance: "PCI-DSS Compliance",
  CISOInsights: "CISO Insights",
  trmgCompliance: "TRMG Compliance",
  circular09Compliance: "Circular 09 Compliance",
  securityHubFindings: "Security Hub Findings",
  // "CisoUserAccess": "User Access",
  Questions: "Questions",
  Topics: "Topics",
  Clause: "Clauses",
  SubTopics: "Sub-Topics",
  cloudAccessReview: "Cloud Access Governance",
  cloudAccessGovernance: "Access Governance",
  accessreview: "Access Review",
  SummaryPDF: "Summary PDF",
  ConfigurationFilter: "Configuration Filter",
  policyInsights: "Policy Insights",
  SummaryPDF: "Summary PDF",
  CISBenchmarkCompliance: "CIS Benchmark Compliance",
  CloudCostInsights: "Cloud Cost Insights",
  licenseManagement: "License Management",
  AdminActivity: "Admin Activity",
  efficiency: "Efficiency",
  appConfig: "App Config",
  accessManagement: "Access Management",
  myRequest: "My Request",
  myApproval: "My Approval",
  auditLog: "Audit Log",
  configuration: "Configuration",
  settings: "Settings",
  tools: "Tools",
  groups: "Groups",
  PIIDataConfiguration: "PII Data Configuration",
  IAMPolicyCategorization: "IAM Policy Categorization",
  AWSStateCategorization: "AWS State Categorization",
  AWSConfiguration: "AWS Configuration",
  EmailScheduleConfiguration: "Email Schedule Configuration",
  DataImportScheduler: "Data Import",
  administration: "Administration",
  ldapConfig: "LDAP Configuration",
  smtpConfig: "SMTP Configuration",
  licenseConfig: "License Configuration",
  userManagement: "User Management",
  loggingConfig: "Logging Configuration",
  BusinessInfoConfig: "Business Info",
  roleAllocation: "Role Allocation",
  CMDBOverview: "CMDB Overview",
  UserInfoConfig: "Users",
  cloudaccounttable: "",
  cloudaccount: "Cloud Accounts",
  CloudCost: "Cloud Cost",
  AssessmentQuestionnaire: "Assessment Questionnaire",
  licenseconfigpage: "OS License",
  observability: "DevOps Insights",
  flowMetrics: "Flow Metrics",
  QAMetrics: "QA Metrics",
  doraMetrics: "Dora Metrics",
  peopleMetrics: "People Metrics",
  productivityMetrics: "Productivity Metrics",
  devopsMetrics: "Devops Metrics",
  opsMetrics: "Ops Metrics",
  DevExQuadrant: "DevEx Quadrant",
  incidentManagement: "Incident Management",
  changeManagement: "Change Management",
  userReview: "Application User Access Review",
  home: "Home",
  DeviceConfig: "Devices",
  users: "Users",
  accountids: "Cloud Accounts",
  Devices: "Devices",
  applicationConfiguration: "Application Configuration",
  project: "Projects",
  Summary: "Summary",
  sonarqubeRole: "SonarQube Roles",
  confluencecloudRole: "Confluence Cloud Roles",
  jiraRole: "Jira Configuration",
  jiracloudRole: "Jira Cloud Roles",
  jfrogRole: "JFrog Roles",
  nexusRole: "Nexus Roles",
  jenkinsRole: "Jenkins Roles",
  bitbucketRole: "Bitbucket Roles",
  bambooRole: "Bamboo Roles",
  SeveritySLAConfigurationRole: "Severity SLA Configuration",
  onboardingtools: "Onboard Tools",
  Architecture: "Architecture",
  cloudInsights: "Cloud Insights",
  compliance: "Compliance",
  Compliance: "Compliance",
  "3DOverview": "3D Overview",
  complianceAssessment: "Risk Assessement",
  Assessment: "Assessment",
  SBOMCISO: "SBOM CISO",
  RMiTCompliance: "RMiT Compliance",
  regulatoryCompliance: "Regulatory Compliance",
  SDLCInsights: "SDLC Insights",
  Servers: "Servers",
  ArchitectureCompliance: "Architecture Compliance",
  architectureCompliance: "Architecture Compliance",
  Overview: "Overview",
  CostOverview: "Cost Overview",
  CostInsights: "Cost Insights",
  cisoriskAssessment: "Risk Assessement",
  RiskAssessement: "Risk Assessement",
  RiskAssessment: "Risk and Audit Management ",
  projects: "Projects",
  jiraconfiguration: "Jira Configuration",
  "on-premise": "On-Premise",
  cloud: "Cloud",
  assetCoverage: "Asset Coverage",
};

export const userRestrictedAccess = [
  "/efficiency/onboardingtools",
  "/onboardingtools",
  "/efficiency/myApproval",
  "/configuration/administration/tools",
  "/configuration/administration/groups",
  "/configuration/administration/PIIDataConfiguration",
  "/configuration/administration/ldapConfig",
  "/configuration/administration/smtpConfig",
  "/configuration/administration/licenseConfig",
  "/configuration/administration/userManagement",
  "/configuration/administration/loggingConfig",
];
